export const getLoading = state => state.search.loading;
export const getStocks = state => state.search.stocks;
export const getPhrase = state => state.search.phrase;
export const getFetchMoreResultsUrl = state => state.search.next;
export const getLoadingMore = state => state.search.loadingMore;
export const getSymbols = state => state.search.symbols;
